/* eslint-disable no-plusplus */
function isBlankRow(imageData, width, y) {
    const offsetY = y * width * 4;
    for (let x = 0; x < width; ++x) {
        if (imageData.data[offsetY + x * 4 + 3] !== 0) {
            return false;
        }
    }
    return true;
}
function isBlankColumn(imageData, width, x, top, bottom) {
    const offsetY = width * 4;
    const offsetX = x * 4 + 3;
    for (let y = top; y < bottom; ++y) {
        if (imageData.data[y * offsetY + offsetX] !== 0) {
            return false;
        }
    }
    return true;
}
export function getEdgeTransparencyInsets(canvas, bounds) {
    const ctx = canvas.getContext('2d');
    bounds = bounds !== null && bounds !== void 0 ? bounds : {
        x: 0,
        y: 0,
        width: canvas.width,
        height: canvas.height,
    };
    const imageData = ctx.getImageData(bounds.x, bounds.y, bounds.width, bounds.height);
    let top = 0;
    let bottom = imageData.height;
    let left = 0;
    let right = imageData.width;
    while (top < bottom && isBlankRow(imageData, imageData.width, top)) {
        top += 1;
    }
    while (bottom - 1 > top &&
        isBlankRow(imageData, imageData.width, bottom - 1)) {
        bottom -= 1;
    }
    while (left < right &&
        isBlankColumn(imageData, imageData.width, left, top, bottom)) {
        left += 1;
    }
    while (right - 1 > left &&
        isBlankColumn(imageData, imageData.width, right - 1, top, bottom)) {
        right -= 1;
    }
    return {
        left,
        top,
        right: imageData.width - right,
        bottom: imageData.height - bottom,
    };
}
